import { useMemo } from 'react';

import { Checkbox } from '#/components/Checkbox/Checkbox';
import { getFieldQaId } from '#/components/Form/Field/getFieldQaId';
import { LargeCheckbox } from '#/components/LargeCheckbox/LargeCheckbox';

import { CheckboxContainer, Checkboxes_Box_1 } from './Checkboxes.styled';
import type { CheckboxOption } from './CheckboxOption';

type Props = {
  id?: string;
  getValue: (optionName: string) => unknown;
  options: CheckboxOption[] | readonly CheckboxOption[];
  columns?: 1 | 2 | 3 | 4 | 5 | 6 | 7;
  hasError?: boolean;
  onChange: (checkboxName: string, value: boolean) => void;
  disabled?: boolean;
  value?: string;
  large?: boolean;
  fullWidth?: boolean;
  getQaId?: (checkboxName: string) => string;
  qaId: string;
};

export function Checkboxes({
  id,
  getValue,
  options,
  columns,
  hasError,
  onChange,
  disabled,
  value,
  large,
  fullWidth,
  getQaId,
  qaId,
}: Props) {
  const CheckboxComponent = useMemo(() => {
    if (large) {
      return LargeCheckbox;
    }
    return Checkbox;
  }, [large]);

  const getCheckboxQaId = getQaId ?? getFieldQaId;

  return (
    <CheckboxContainer
      $columns={columns}
      $large={large}
      $hasError={hasError}
      data-qa-id={qaId}
    >
      {options.map(({ label: checkboxLabel, name: checkboxName }, index) => (
        <Checkboxes_Box_1
          key={checkboxName}
          data-has-columns={columns ? true : undefined}
          style={{
            '--w-sm': columns ? (100 / columns).toFixed(2) + '%' : undefined,
            paddingRight:
              !columns && !large && index !== options.length - 1 ? '50px' : 0,
            padding: large ? '6px' : undefined,
          }}
        >
          <CheckboxComponent
            name={checkboxName}
            label={checkboxLabel}
            id={index === 0 ? (id ?? qaId) : `${id ?? qaId}-${checkboxName}`}
            qaId={`${qaId}-${getCheckboxQaId(checkboxName)}`}
            onChange={(e) => {
              onChange(checkboxName, e);
            }}
            checked={Boolean(getValue(checkboxName))}
            disabled={disabled}
            value={value}
            fullWidth={fullWidth}
          />
        </Checkboxes_Box_1>
      ))}
    </CheckboxContainer>
  );
}
